import { render, staticRenderFns } from "./AppDownloadBanner.vue?vue&type=template&id=99549004&"
import script from "./AppDownloadBanner.vue?vue&type=script&lang=js&"
export * from "./AppDownloadBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports